import React, { useEffect, useState } from "react";
import { APP_NAME, APP_VERSION, APP_VENDOR } from "@/lib/app";
import { useLang } from "@/i18n";

export default function Footer() {
  const { lang } = useLang();
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const loc = lang === "es" ? "es-ES" : "nl-BE";
  return (
    <footer
      className="h-7 shrink-0 sticky bottom-0 z-20 border-t border-sky-200 bg-secondary/70 px-4 flex items-center justify-between text-[11px] text-muted-foreground print:hidden"
      data-testid="app-footer"
    >
      <span className="font-semibold tracking-wide" data-testid="footer-app">{APP_NAME} v{APP_VERSION}</span>
      <span className="tabular-nums" data-testid="footer-clock">
        {now.toLocaleDateString(loc, { day: "2-digit", month: "2-digit", year: "numeric" })} · {now.toLocaleTimeString(loc, { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
      </span>
      <span data-testid="footer-vendor">{APP_VENDOR}</span>
    </footer>
  );
}
